const GoogleIcon = () => {
	return (
		<svg
			width='21'
			height='20'
			viewBox='0 0 21 20'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'>
			<path
				d='M10.6992 8.18164V12.0544H16.081C15.8447 13.2998 15.1355 14.3544 14.0719 15.0635L17.3173 17.5817C19.2082 15.8363 20.2991 13.2726 20.2991 10.2272C20.2991 9.51811 20.2355 8.83623 20.1173 8.18175L10.6992 8.18164Z'
				fill='#4285F4'
			/>
			<path
				d='M5.0944 11.9033L4.36243 12.4636L1.77148 14.4818C3.41693 17.7454 6.7894 20 10.6985 20C13.3984 20 15.662 19.109 17.3166 17.5818L14.0711 15.0636C13.1802 15.6636 12.0439 16.0273 10.6985 16.0273C8.09848 16.0273 5.88945 14.2728 5.09849 11.9091L5.0944 11.9033Z'
				fill='#34A853'
			/>
			<path
				d='M1.77187 5.51807C1.09009 6.86346 0.699219 8.38166 0.699219 9.99981C0.699219 11.618 1.09009 13.1362 1.77187 14.4816C1.77187 14.4906 5.09919 11.8998 5.09919 11.8998C4.89919 11.2998 4.78098 10.6634 4.78098 9.99971C4.78098 9.33599 4.89919 8.69967 5.09919 8.09967L1.77187 5.51807Z'
				fill='#FBBC05'
			/>
			<path
				d='M10.6987 3.98181C12.1714 3.98181 13.4805 4.49089 14.5259 5.47272L17.3895 2.60912C15.6532 0.990969 13.3987 0 10.6987 0C6.78961 0 3.41693 2.24545 1.77148 5.51818L5.09871 8.1C5.88957 5.73634 8.09868 3.98181 10.6987 3.98181Z'
				fill='#EA4335'
			/>
		</svg>
	);
};

export default GoogleIcon;
